export abstract class AppIcons {
  private static readonly iconsDirPath = '../assets/icons';

  static readonly appIconPath = `${AppIcons.iconsDirPath}/ic_focal_48.png`;
}
